<script setup>
import { useCookieConsent } from '@/composables/useCookieConsent';
const { $_, $auth } = useNuxtApp()

const { consentGiven, giveConsent, revokeConsent } = useCookieConsent();

const accept = () => {
    giveConsent();
};

const reject = () => {
    revokeConsent();
};
</script>

<template>
    <div v-if="consentGiven === null ||consentGiven === undefined" class="cookies">
        <div class="title">
            <p>
                {{ $_('cookie-consent.title') }}
            </p>
            <img class="mx-auto" src="~/assets/img/landing/step-1.svg" alt="Step 1 image" />
        </div>

        <div class="options">
            <button @click="accept">{{ $_('cookie-consent.accept') }}</button>
            <button @click="reject">{{ $_('cookie-consent.reject') }}</button>
        </div>
    </div>
</template>



<style scoped>
img{
    margin: 0;
    padding: 0;
    width: 80px;
}
.options {
    display: flex;
    justify-content: center;
    gap: 8px;
}

.title {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    margin-bottom: 12px;
}

.title p {
    margin: 0;
    padding: 0;
}

.cookies {
    background-color: #fff;
    border-top: 2px solid rgb(86, 151, 9);
    ;
    padding: 16px;
}

button {
    margin: 0 5px;
    padding: 5px 10px;
    background-color: rgb(86, 151, 9);
    border: none;
    color: white;
    cursor: pointer;
    border-radius: 8px;
}

button:last-child {
    background-color: #fff;
    color: rgb(86, 151, 9);
    border: 2px solid rgb(86, 151, 9);
}
</style>